<template>
  <div id="app">
    <header class="header">
      <h1>大厅</h1>
      <input 
        type="text" 
        placeholder="搜索游戏..." 
        v-model="searchKeyword" 
        class="search-input"
      />
    </header>

    <main class="main">
      <div class="game-list">
        <!-- 使用 v-for 循环渲染卡片 -->
        <div 
          v-for="game in filteredGames" 
          :key="game.id" 
          class="game-card"
          @click="handleGameClick(game)"
        >
          <img :src="game.cover" :alt="game.title" />
          <h3>{{ game.title }}</h3>
          <p>{{ game.desc || (game.type === 'external' ? '外部官网' : '') }}</p>
          <!-- 如果是外部游戏，显示外部徽章（可选） -->
          <span v-if="game.type === 'external'" class="external-badge">
            <i class="fas fa-external-link-alt"></i>
          </span>
        </div>
      </div>
    </main>

    <footer class="footer">
      <p>本站仅为导航，所有外部链接均为官方提供</p>
    </footer>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const searchKeyword = ref('')

// 所有游戏数据集中管理
const games = ref([
  {
    id: 'my-game1',
    title: '小游戏',
    desc: '经典休闲游戏',
    cover: 'https://picsum.photos/200/150?random=1',
    type: 'internal',     // 内部游戏
    route: '/play/my-game1' // 内部游戏的路由
  },
  {
    id: 'douyin',
    title: '刷抖音短视频',
    desc: '',
    cover: 'https://picsum.photos/200/150?random=2',
    type: 'external',
    url: 'https://www.douyin.com/'
  },
  {
    id: 'doubao',
    title: '豆包AI助手',
    desc: '',
    cover: 'https://picsum.photos/200/150?random=3',
    type: 'external',
    url: 'https://www.doubao.com/'
  }
])

// 搜索过滤：匹配标题或描述
const filteredGames = computed(() => {
  const keyword = searchKeyword.value.trim().toLowerCase()
  if (!keyword) return games.value
  return games.value.filter(game => 
    game.title.toLowerCase().includes(keyword) || 
    (game.desc && game.desc.toLowerCase().includes(keyword))
  )
})

// 处理卡片点击
const handleGameClick = (game) => {
  if (game.type === 'internal') {
    router.push(game.route)
  } else if (game.type === 'external') {
    window.open(game.url, '_blank', 'noopener noreferrer')
  }
}
</script>

<style scoped>
/* 原有样式保留，添加一些优化 */
.header {
  padding: 20px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.search-input {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 250px;
}
.main {
  padding: 20px;
}
.game-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: flex-start;
}
.game-card {
  width: 200px;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;
}
.game-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}
.game-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}
.game-card h3 {
  padding: 8px;
  margin: 0;
  font-size: 16px;
}
.game-card p {
  padding: 0 8px 8px;
  margin: 0;
  color: #666;
  font-size: 14px;
}
.external-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0,0,0,0.6);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.footer {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 12px;
  border-top: 1px solid #eee;
}

/* 响应式 */
@media (max-width: 600px) {
  .header {
    flex-direction: column;
    align-items: stretch;
  }
  .search-input {
    width: 100%;
  }
  .game-list {
    justify-content: center;
  }
}
</style>